import { Account, Person, ServiceProvider } from "@/types";

export const isBiometricsNeeded = (
  accounts: ReadonlyArray<Account> | undefined,
  spMap: Record<string, ServiceProvider>
): boolean => {
  return !!accounts?.some(
    (account: Account) => account.companyId && spMap[account.companyId]?.faceSimilarityNeeded
  );
};
